/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStammdatenDto } from '../../models/lexplus-stammdaten-dto';
import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';
import { LexplusUpdateStammdatenDto } from '../../models/lexplus-update-stammdaten-dto';

export interface StammdatenControllerUpdateV1$Params {
  id: number;
  typ: LexplusStammdatenTyp;
      body: LexplusUpdateStammdatenDto
}

export function stammdatenControllerUpdateV1(http: HttpClient, rootUrl: string, params: StammdatenControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStammdatenDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('typ', params.typ, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStammdatenDto>;
    })
  );
}

stammdatenControllerUpdateV1.PATH = '/v1/stammdaten/{typ}/{id}';
